import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import classnames from 'classnames';
import Color from 'color';

import { AppState } from 'services/types';
import { GroupsProps } from 'services/groups/types';
import HarvestEventEntityPathNamesReversedValue from 'components/HarvestEventEntityPathNamesReversedValue';
import HarvestEventPickTypeExternalIdValue from 'components/HarvestEventPickTypeExternalIdValue';
import HarvestEventQuantitySchedulesSummaryValue from 'components/HarvestEventQuantitySchedulesSummaryValue';
import HarvestEventMultipleGroupsStatus from 'components/HarvestEventMultipleGroupsStatus';
import HarvestEventVarietyShortNameValue from 'components/HarvestEventVarietyShortNameValue';
import HarvestEventUploadStatus from 'components/HarvestEventUploadStatus';
import SemiBold from 'components/SemiBold';
import { makeSelectGroupColor } from 'services/groups/selectors';

import { HEIGHT } from '../../constants';
import './styles.scss';

interface OwnProps extends GroupsProps {
    harvestEventUuid: string;
    overflowRight?: boolean;
    overflowLeft?: boolean;
    width: number | string;
    onBlur?: any;
    onClick?: any;
    onFocus?: any;
    onMouseEnter?: any;
    onMouseLeave?: any;
    draggingDisabled?: boolean;
}

interface ConnectedProps {
    color?: ReturnType<ReturnType<typeof makeSelectGroupColor>>;
}

type Props = OwnProps & ConnectedProps;

export class StyledEventsTimelineEvent extends React.PureComponent<Props> {
    render(): React.ReactElement {
        const {
            harvestEventUuid,
            groupId,
            overflowRight,
            overflowLeft,
            width,
            color,
            onBlur,
            onClick,
            onFocus,
            onMouseEnter,
            onMouseLeave,
            draggingDisabled
        } = this.props;
        const background = color || 'rgb(204, 204, 204)';
        const darkBackground = Color(background).darken(0.7);

        const className = classnames('styled-events-timeline-event', {
            'styled-events-timeline-event-overflow-right': overflowRight,
            'styled-events-timeline-event-overflow-left': overflowLeft,
            'styled-events-timeline-event-drop-shadow': !onClick,
            'styled-events-timeline-event-dragging-disabled': draggingDisabled
        });

        const WrapperProps = {
            className: 'styled-events-timeline-event-container',
            style: { width, height: HEIGHT }
        };

        const Content = (
            <div className={className}>
                <div
                    className="styled-events-timeline-event-pick"
                    // @ts-ignore
                    style={{ backgroundColor: darkBackground }}
                >
                    <HarvestEventPickTypeExternalIdValue
                        harvestEventUuid={harvestEventUuid}
                    />
                </div>
                <div
                    className="styled-events-timeline-event-details"
                    style={{ backgroundColor: background }}
                >
                    <div className="row">
                        <SemiBold>
                            <HarvestEventVarietyShortNameValue
                                harvestEventUuid={harvestEventUuid}
                            />
                        </SemiBold>{' '}
                        -{' '}
                        <HarvestEventEntityPathNamesReversedValue
                            harvestEventUuid={harvestEventUuid}
                        />
                    </div>
                    <div className="row">
                        <HarvestEventQuantitySchedulesSummaryValue
                            harvestEventUuid={harvestEventUuid}
                            groupId={groupId}
                        />
                    </div>
                    <div
                        className="row"
                        style={{
                            marginTop: 1
                        }}
                    >
                        <HarvestEventUploadStatus
                            harvestEventUuid={harvestEventUuid}
                        />
                        <HarvestEventMultipleGroupsStatus
                            harvestEventUuid={harvestEventUuid}
                        />
                    </div>
                </div>
            </div>
        );

        if (!onClick) {
            return <div {...WrapperProps}>{Content}</div>;
        }

        return (
            <button
                {...WrapperProps}
                onBlur={onBlur}
                onClick={onClick}
                onFocus={onFocus}
                onMouseEnter={onMouseEnter}
                onMouseLeave={onMouseLeave}
                type="button"
            >
                {Content}
            </button>
        );
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    color: makeSelectGroupColor()
});

export default connect(mapStateToProps)(StyledEventsTimelineEvent);
